module.exports = __webpack_public_path__ + "img/cover.670e23d2.webp";